export default __webpack_public_path__ + "static/media/emblem_grey_5.f460e7c2.png";